export default {
  'app.pwa.offline': 'თქვენ ახლა ოფლაინ რეჟიმში ხართ',
  'app.pwa.serviceworker.updated': 'ახალი შინაარსი ხელმისაწვდომია',
  'app.pwa.serviceworker.updated.hint':
    'გთხოვთ დააჭიროთ "განახლება" ღილაკს გვერდის თავიდან ჩატვირთვისთვის',
  'app.pwa.serviceworker.updated.ok': 'განახლება',
};
